import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { BinReservationGenDocLinkContainer } from '../../../../../../models/aggregates/erp/stock';
import { Core2Config } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class BinReservationGenDocLinkService extends BaseApiTemplateService<BinReservationGenDocLinkContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'bin-reservation-gen-doc-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'bin-reservation-gen-doc-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'bin-reservation-gen-doc-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}